import { ValidationError } from "sequelize"
import { MtProjectGroup, MtProjectGroupCreate, MtProjectGroupSaveMany } from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import { LangType } from "client/store"
import {
    ProjectGroupList,
    ProjectGroupFilters,
    ProjectGroupValidation,
} from "./types"


export const LoadProjectGroups = (
    accountId: number,
    projectId: number,
    defaultGroupsAssigned: boolean,
) => (
    GET(`/mtProjectGroup/projectId/${projectId}/accountId/${accountId}/${defaultGroupsAssigned}`)
    .then((groups: MtProjectGroup[]) => {
        const groupList: ProjectGroupList = {}
        groups.forEach((group) => {
            groupList[group.groupId] = group
        })
        return groupList
    })
)

export const LoadProjectGroupById = (
    groupId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/mtProjectGroup/groupId/${groupId}/projectId/${projectId}/accountId/${accountId}`)
    .then((group: MtProjectGroup) => group)
)

export const SaveProjectGroup = (
    group: MtProjectGroupCreate,
    lang: LangType,
) => (
    POST(
        "/mtProjectGroup/save",
        JSON.stringify(group),
    ).then((res) => {
        const newGroup = res as MtProjectGroup
        const error = res as ValidationError
        return {
            newGroupId: newGroup.groupId || null,
            newGroupOrder: newGroup.order || null,
            validation: <ProjectGroupValidation>validate(error, lang),
        }
    })
)

export const DragnDropProjectGroup = (
    groupIds: readonly number[],
    accountId: number,
    projectId: number,
) => {
    const data: MtProjectGroupSaveMany = {
        groupIds,
        accountId,
        projectId,
    }

    return POST(
        "/mtProjectGroup/updateMany",
        JSON.stringify(data),
    ).then((success: boolean) => success)
}

export const DeleteProjectGroup = (
    groupId: number,
    accountId: number,
    projectId: number,
) => (
    DELETE(`/mtProjectGroup/delete/groupId/${groupId}/projectId/${projectId}/accountId/${accountId}`)
    .then((removedRows: number) => removedRows)
)

export const SortProjectGroups = (
    groups: MtProjectGroup[],
    sortColumn: keyof MtProjectGroup,
    sortOrder: OrderType,
    filters: ProjectGroupFilters,
) => {
    const groupsFiltered = groups.filter((group) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, group)
        return showRow
    })
    groupsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const groupIds: number[] = []
    groupsFiltered.forEach((group) => groupIds.push(group.groupId))

    return groupIds
}

export const CopyDefaultProjectGroups = (
    accountId: number,
    projectId: number,
    defaultGroupsAssigned: boolean,
) => (
    GET(`/mtProjectGroup/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultGroupsAssigned}`)
    .then((success: boolean) => success)
)
